export function deepMerge(target: any, source: any): any {
  if (typeof target !== 'object' || target === null) return source
  if (typeof source !== 'object' || source === null) return source

  const output = Array.isArray(target) ? [...target] : { ...target }

  for (const key of Object.keys(source)) {
    if (
      source[key] &&
      typeof source[key] === 'object' &&
      !Array.isArray(source[key])
    ) {
      output[key] = deepMerge(target[key], source[key])
    } else {
      output[key] = source[key]
    }
  }

  return output
}

export const replaceEmptyWithNull = <T>(obj: T): T => {
  if (obj === null || obj === undefined || obj === '') return null as T

  if (typeof obj !== 'object') return obj

  if (Array.isArray(obj)) return obj.map(replaceEmptyWithNull) as T

  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key,
      replaceEmptyWithNull(value ?? null)
    ])
  ) as T
}

export const replaceEmptyWithUndefined = <T>(obj: T): T => {
  if (obj === null || obj === undefined || obj === '') return undefined as T

  if (typeof obj !== 'object') return obj

  if (Array.isArray(obj)) return obj.map(replaceEmptyWithUndefined) as T

  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key,
      replaceEmptyWithUndefined(value ?? undefined)
    ])
  ) as T
}
